<script>
import "@vueform/multiselect/themes/default.css";

import Layout from "../../layouts/main";
import appConfig from "../../../app.config";
// import PageHeader from "@/components/page-header";
import ReportList from "@/views/service-report/components/report-list";
import i18n from "@/i18n";

export default {
  page: {
    title: i18n.global.t('page.serviceReport'),
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  data() {
    return {
      title: this.$t('page.serviceReport'),
      items: [{
        text: this.$t('page.afterSalesService'),
        href: "/",
      },
        {
          text: this.$t('page.serviceReport'),
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    // PageHeader,
    ReportList,
  },
  computed: {

  },
  watch: {

  },

  methods: {

  },
};
</script>

<template>
  <Layout>
<!--    <PageHeader :title="title" :items="items" />-->
    <ReportList></ReportList>
  </Layout>

</template>
